import {createAction, props} from "@ngrx/store";
import {Serializers} from "../../interfaces/serializer";
import {DataSourceMetric} from '../../interfaces/metrics';
import {ActionCreator, TypedAction} from '@ngrx/store/src/models';

export const loadDataSourcesMetrics: ActionCreator<'[DATA_SOURCES_METRICS] LOAD', () => TypedAction<'[DATA_SOURCES_METRICS] LOAD'>> = createAction('[DATA_SOURCES_METRICS] LOAD');
export const loadDataSourcesMetricsSuccess = createAction(
  '[DATA_SOURCES_METRICS] LOAD_SUCCESS',
  props<{ metrics: Serializers<DataSourceMetric> }>()
);
export const dataSourcesMetricsLoadState = createAction('[DATA_SOURCES_METRICS] LOAD_STATE');
